import axios from "axios";
import { authConfig, endpoint, multipartAuthConfig } from "./http";

export async function listPublicShops({ apiUrl, query = "" }) {
  const response = await axios.get(endpoint(apiUrl, "/shop"), {
    params: query.trim() ? { q: query.trim() } : undefined,
  });
  return response.data;
}

export async function getPublicShop({ apiUrl, shopId }) {
  const response = await axios.get(endpoint(apiUrl, `/shops/${shopId}`));
  return response.data;
}

export async function getShopReviews({ apiUrl, shopId }) {
  const response = await axios.get(endpoint(apiUrl, `/shops/${shopId}/reviews`));
  return response.data;
}

export async function getShopFollowing({ accessToken, apiUrl, shopId }) {
  const response = await axios.get(endpoint(apiUrl, `/shops/${shopId}/following`), authConfig(accessToken));
  return response.data;
}

export async function followShop({ accessToken, apiUrl, shopId }) {
  const response = await axios.post(endpoint(apiUrl, `/shops/${shopId}/followers`), {}, authConfig(accessToken));
  return response.data;
}

export async function unfollowShop({ accessToken, apiUrl, shopId }) {
  const response = await axios.delete(endpoint(apiUrl, `/shops/${shopId}/followers`), authConfig(accessToken));
  return response.data;
}

export async function createShopReview({ accessToken, apiUrl, review, shopId }) {
  const response = await axios.post(endpoint(apiUrl, `/shops/${shopId}/reviews`), review, authConfig(accessToken));
  return response.data;
}

export async function listMyShops({ accessToken, apiUrl }) {
  const response = await axios.get(endpoint(apiUrl, "/shops/me"), authConfig(accessToken));
  return response.data;
}

export async function createShop({ accessToken, apiUrl, shop }) {
  const response = await axios.post(endpoint(apiUrl, "/shops"), shop, authConfig(accessToken));
  return response.data;
}

export async function updateShop({ accessToken, apiUrl, shop, shopId }) {
  const response = await axios.patch(endpoint(apiUrl, `/shops/${shopId}`), shop, authConfig(accessToken));
  return response.data;
}

export async function deleteShop({ accessToken, apiUrl, shopId }) {
  const response = await axios.delete(endpoint(apiUrl, `/shops/${shopId}`), authConfig(accessToken));
  return response.data;
}

export async function uploadMiniShopLogo({ accessToken, apiUrl, logo, shopId }) {
  const formData = new FormData();
  formData.append("logo", logo);
  const response = await axios.post(
    endpoint(apiUrl, `/shops/${shopId}/logo`),
    formData,
    multipartAuthConfig(accessToken)
  );
  return response.data;
}

export async function uploadMiniShopCover({ accessToken, apiUrl, cover, shopId }) {
  const formData = new FormData();
  formData.append("cover", cover);
  const response = await axios.post(
    endpoint(apiUrl, `/shops/${shopId}/cover`),
    formData,
    multipartAuthConfig(accessToken)
  );
  return response.data;
}

export async function getMyShop({ accessToken, apiUrl }) {
  const response = await axios.get(endpoint(apiUrl, "/shop/me"), authConfig(accessToken));
  return response.data;
}

export async function updateMyShop({ accessToken, apiUrl, shop }) {
  const response = await axios.patch(endpoint(apiUrl, "/shop/me"), shop, authConfig(accessToken));
  return response.data;
}

export async function uploadShopLogo({ accessToken, apiUrl, logo }) {
  const formData = new FormData();
  formData.append("logo", logo);
  const response = await axios.post(
    endpoint(apiUrl, "/shop/me/logo"),
    formData,
    multipartAuthConfig(accessToken)
  );
  return response.data;
}
